<template>
    <full-list 
        :sendOptions="sendOptions"
        :options="options"
        :optionsAll="optionsAll"
        :optionsSelected="[optionSelected]"
    />
</template>

<script>

    import FullList from './full-list.vue';

    export default{
        data(){
            return{
                optionSelected: null
            }
        },
        components: {
            "full-list": FullList,
        },
        created(){
            if(this.riskValueSelected) {
                const optionSelected = this.options?.find(option => option.product_option_value_price === this.riskValueSelected);
                if(optionSelected) this.optionSelected = optionSelected.product_option_value_id;
            }
            this.$on('optionsSending', function(optionValues, canGoToNextStep) { 
                const optionSelected = optionValues[0];
                let riskValue = optionSelected && (this.options.find(option => option.product_option_value_id === optionSelected) || {}).product_option_value_price;
                this.$parent.$emit('riskValueSending', riskValue, canGoToNextStep && riskValue);
            });
        },
        props: ['options', 'sendOptions', 'optionsAll', 'optionsSelected', 'riskValueSelected'],
    }
</script>